import React, { useRef, useEffect } from 'react';
import { useJarvisState } from '../hooks/useJarvisState';

interface SplineSceneProps {
  className?: string;
}

const SplineScene: React.FC<SplineSceneProps> = ({ className = '' }) => {
  const { state } = useJarvisState();
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    iframe.contentWindow?.postMessage({
      type: 'jarvis-state',
      state: state
    }, '*');
  }, [state]);

  return (
    <div ref={containerRef} className="absolute inset-0 w-full h-full overflow-hidden pointer-events-none">
      <div className={`absolute inset-0 transition-opacity duration-500 ${
        state === 'thinking' ? 'opacity-50' : 'opacity-0'
      } bg-primary/10 animate-pulse`} />
      
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="relative w-full h-full">
          <iframe 
            ref={iframeRef}
            src='https://my.spline.design/meeet-5ce2cffd31f30a704ff19b1e1481c7fa/' 
            frameBorder='0' 
            className="w-full h-full"
            style={{ 
              transform: state === 'listening' ? 'scale(1.02)' : 'scale(1)',
              filter: state === 'speaking' ? 'brightness(1.1)' : 'none',
              transition: 'all 0.4s ease-out',
              transformOrigin: 'center center'
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default SplineScene;